<template>
  <div class="card my-3">
    <div class="card-body">
      <div class="row align-items-center">
        <slot name="header" />
        <div class="col-12 col-sm-auto ml-sm-auto">
          <slot name="button" />
          <button type="button" class="dashboard__details-btn btn thin collapsed" :class="'btn-' + $mainColor" data-toggle="collapse" :data-target="'#itemDetails' + item.id" aria-expanded="false" :aria-controls="'itemDetails' + item.id">
            {{ buttonTitle }}
            <i class="bestove-icon__arrow-top ml-h"></i>
          </button>
        </div>
      </div>

      <div class="collapse mt-4" :class="{'show': isShow(item.id) }" :id="'itemDetails' + item.id">
        <slot name="body" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapseCard',
  props: {
    item: {
      type: Object,
      required: true
    },
    buttonTitle: {
      type: String,
      default: 'Détails'
    }
  },
  methods: {
    isShow (id) {
      return id === parseInt(this.$route.query.id)
    }
  }
}
</script>
